import axios from "axios";
import Constants from "expo-constants";

const baseUrl = Constants.manifest.extra.uri;

export const initPayment = async (body) => {
  const response = await axios.post(`${baseUrl}/payments`, body);
  return response.data;
};